module.exports = __webpack_public_path__ + "static/media/acropolismys.4b195c77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/rimages/acropolismys.jpg
// module id = 70
// module chunks = 0